import { cloneDeep } from 'lodash';

export const getDeepCopy = cloneDeep;
